declare let adminAppConfig: IConfiguration;

export interface IConfiguration {
    adminApiBaseUrl : string;
    msal : IMsalConfiguration;
    parentFrameDomain: string;
}

export interface IMsalConfiguration {
    authority : string;
    clientId : string;
    scopes: Array<string>;
}

export const getConfiguration = () : IConfiguration => adminAppConfig;
